export enum ETrackingEvent {
  GetStarted = 'get_started',
  PrequalSuccess = 'prequal_success',
  PrequalDeclined = 'prequal_declined',
  QualifSuccess = 'qualif_success',
  QualifDeclined = 'qualif_declined',
  WithdrewManualRevision = 'withdrew_manual_revision',
  WithdrewAfterPrequal = 'withdrew_after_prequal',
  WithdrewAfterQualif = 'withdrew_after_qualif',
}

export interface DataLayerEvent {
  event: ETrackingEvent // The event name (e.g., 'get_started', 'prequal_success')
  form_id?: string // Unique identifier for the form submission
  credit_application_id?: string // Unique identifier for the credit application
  reference_number?: number // Credit application reference number
  loan_info?: LoanInfo // Information about the loan
}

export interface LoanInfo {
  loan_amount?: number // Loan amount ( e.g., 15000.00)
  loan_interest_rate?: number // Interest rate percentage (e.g., 3.75)
  loan_duration?: number // Loan duration in months (e.g., 60)
}
